import { axiosAppServices } from 'utils/axios';
import type { SupportDiagnosticPayload } from './types';

export async function submitSupportDiagnostics(payload: SupportDiagnosticPayload): Promise<void> {
  await axiosAppServices.post('/api/support/diagnostics', payload, {
    skipGlobalLoading: true,
  });
}
